// src/sections/CTA.jsx
import Container from "../components/ui/Container";
import Button from "../components/ui/Button";
import { Link } from "react-router-dom";

export default function CTA() {
    return (
        <section data-aos="fade-up" data-aos-duration="800" className="py-16 lg:py-24">
            <Container>
                <div className="relative rounded-3xl bg-gradient-to-br from-brand-600 via-brand-700 to-brand-800 p-8 sm:p-12 lg:p-16 overflow-hidden">
                    {/* Background decoration */}
                    <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl" />
                    <div className="absolute bottom-0 left-0 w-48 h-48 bg-black/10 rounded-full blur-2xl" />
                    
                    <div className="relative flex flex-col lg:flex-row items-center justify-between gap-8 text-center lg:text-left">
                        {/* Textbereich */}
                        <div className="max-w-xl">
                            <span className="inline-block px-4 py-1.5 rounded-full bg-white/20 text-white/90 text-xs font-bold uppercase tracking-wider mb-4">
                                Kostenlose Fachberatung
                            </span>
                            <h3 className="text-3xl sm:text-4xl font-heading font-bold leading-tight text-white">
                                Nicht sicher, was du brauchst?
                            </h3>
                            <p className="mt-4 text-brand-100 text-lg">
                                Ich helfe dir bei der Planung, Auswahl und Umsetzung – schnell, unkompliziert und ehrlich.
                            </p>
                        </div>

                        {/* Buttons */}
                        <div className="flex flex-col sm:flex-row gap-4 shrink-0">
                            <a href="tel:+491634194552" className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl bg-white text-brand-700 font-bold text-lg hover:bg-brand-50 transition-colors shadow-lg">
                                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
                                Anrufen
                            </a>
                            <Link to="/kontakt" className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl bg-transparent border-2 border-white/30 text-white font-bold text-lg hover:bg-white/10 transition-colors">
                                Kontakt aufnehmen
                            </Link>
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    );
}
